import { DismissIcon } from '../../SkillsAddPopup/styles/SkillsAddPopup.styled';
import {
  AlertIcon,
  ErrorMessage,
  ErrorMessageContainer,
} from '../styles/common.styled';

interface ErrorsMessageContainerMobileProps {
  errorMessage: string;
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>;
}

export const ErrorsMessageContainerMobile = ({
  errorMessage,
  setErrorMessage,
}: ErrorsMessageContainerMobileProps) => {
  return (
    <ErrorMessageContainer>
      <AlertIcon />
      <ErrorMessage>{errorMessage}</ErrorMessage>
      <DismissIcon onClick={() => setErrorMessage('')} />
    </ErrorMessageContainer>
  );
};
